import React from 'react';

const Header = () => {
  const handleNavClick = (e, id) => {
    e.preventDefault();
    document.getElementById(id).scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header className="bg-retro-red text-white py-6">
      <div className="container mx-auto px-4 flex justify-between items-center">
        <h1 className="text-4xl retro-font">Bud's Grill</h1>
        <nav className="space-x-4">
          <a href="#home" className="hover:underline" onClick={(e) => handleNavClick(e, 'home')}>Home</a>
          <a href="#menu" className="hover:underline" onClick={(e) => handleNavClick(e, 'menu')}>Menu</a>
          <a href="#about" className="hover:underline" onClick={(e) => handleNavClick(e, 'about')}>About</a>
          <a href="#contact" className="hover:underline" onClick={(e) => handleNavClick(e, 'contact')}>Contact</a>
        </nav>
      </div>
    </header>
  );
};

const Hero = () => {
  const handleMenuClick = (e) => {
    e.preventDefault();
    document.getElementById('menu').scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="home" className="bg-retro-blue text-white py-20 text-center">
      <div className="container mx-auto px-4">
        <h2 className="text-5xl retro-font mb-4">Welcome to Bud's Grill!</h2>
        <p className="text-xl mb-6">Serving classic burgers, fries, and shakes since 1955.</p>
        <a
          href="#menu"
          className="bg-retro-red px-6 py-3 rounded-full text-lg hover:bg-red-700 hover-scale"
          onClick={handleMenuClick}
        >
          Check Out Our Menu
        </a>
      </div>
    </section>
  );
};

const MenuItem = ({ title, description, price }) => (
  <div className="bg-white p-6 rounded-lg shadow-lg hover-scale">
    <h3 className="text-2xl retro-font mb-2">{title}</h3>
    <p className="text-gray-600 mb-4">{description}</p>
    <p className="text-lg font-bold">{price}</p>
  </div>
);

const Menu = () => (
  <section id="menu" className="py-16">
    <div className="container mx-auto px-4">
      <h2 className="text-4xl retro-font text-center mb-8">Our Menu</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        <MenuItem
          title="Classic Bud Burger"
          description="Juicy beef patty, lettuce, tomato, onion, pickles, and our special sauce on a toasted bun."
          price="$5.99"
        />
        <MenuItem
          title="Double Cheeseburger"
          description="Two beef patties, double cheese, lettuce, tomato, and mayo."
          price="$7.99"
        />
        <MenuItem
          title="Chili Cheese Fries"
          description="Crispy fries topped with homemade chili and melted cheddar."
          price="$4.49"
        />
        <MenuItem
          title="Vanilla Milkshake"
          description="Creamy vanilla shake made with real ice cream, topped with whipped cream."
          price="$3.99"
        />
        <MenuItem
          title="Chicken Tenders"
          description="Golden fried chicken tenders served with honey mustard."
          price="$6.49"
        />
        <MenuItem
          title="Root Beer Float"
          description="Classic root beer with a scoop of vanilla ice cream."
          price="$3.49"
        />
      </div>
    </div>
  </section>
);

const About = () => (
  <section id="about" className="bg-gray-100 py-16">
    <div className="container mx-auto px-4">
      <h2 className="text-4xl retro-font text-center mb-8">About Bud's Grill</h2>
      <p className="text-lg text-center max-w-2xl mx-auto">
        Bud's Grill has been a local favorite since 1955, serving up hearty burgers, crispy fries, and creamy shakes with a side of nostalgia. Our retro diner vibe and friendly service make every visit feel like a step back in time. Come by and experience the taste of tradition!
      </p>
    </div>
  </section>
);

const Contact = () => {
  const handleContactClick = () => {
    console.log("Thanks for reaching out! We'll get back to you soon.");
  };

  return (
    <section id="contact" className="py-16">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl retro-font text-center mb-8">Get in Touch</h2>
        <div className="text-center">
          <p className="text-lg mb-2"><strong>Address:</strong> 123 Main St, Hometown, USA</p>
          <p className="text-lg mb-2"><strong>Phone:</strong> (555) 123-4567</p>
          <p className="text-lg mb-2"><strong>Hours:</strong> Mon-Sat 11AM-9PM, Sun 12PM-8PM</p>
          <p className="text-lg mb-4"><strong>Email:</strong> <a href="mailto:info@budsgrill.com">info@budsgrill.com</a></p>
          <button
            onClick={handleContactClick}
            className="bg-retro-red text-white px-6 py-3 rounded-full text-lg hover:bg-red-700 hover-scale"
          >
            Send Us a Message
          </button>
        </div>
      </div>
    </section>
  );
};

const Footer = () => (
  <footer className="bg-retro-blue text-white py-6">
    <div className="container mx-auto px-4 text-center">
      <p>&copy; 2025 Bud's Grill. All rights reserved.</p>
    </div>
  </footer>
);

const App = () => (
  <div>
    <Header />
    <Hero />
    <Menu />
    <About />
    <Contact />
    <Footer />
  </div>
);

export default App;